var _circle, _path, _path2, _path3, _path4, _path5, _path6, _path7, _rect, _rect2, _rect3, _rect4, _rect5, _rect6, _rect7, _rect8, _rect9, _rect10, _rect11, _rect12, _rect13, _rect14, _rect15, _rect16, _rect17, _rect18, _rect19, _rect20, _rect21, _rect22, _rect23, _rect24, _rect25, _rect26, _rect27, _rect28, _rect29, _rect30, _rect31, _rect32, _rect33, _path8, _ellipse, _ellipse2, _ellipse3, _path9, _rect34, _rect35, _rect36, _rect37, _rect38, _rect39, _rect40, _rect41, _rect42, _rect43, _rect44, _rect45, _rect46, _rect47, _rect48, _rect49, _rect50, _rect51, _rect52, _rect53, _rect54, _rect55, _rect56, _rect57, _rect58, _rect59, _rect60, _rect61, _rect62, _rect63, _rect64, _rect65, _rect66, _rect67, _rect68, _rect69, _path10, _path11, _path12, _path13, _path14, _circle2, _path15, _path16, _path17, _path18, _path19, _circle3, _path20, _path21, _path22, _path23, _path24, _path25;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgWhySenior(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "10.537 74.814 483.141 310.33",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 343.576,
    cy: -2.255,
    r: 26.701,
    fill: "#fd6584",
    transform: "matrix(.5417 0 0 .51578 61.111 119.296)"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M279.599 111.611c-.834-2.602-3.212-4.484-6.052-4.791a.8.8 0 0 0-.098 0 .738.738 0 0 0-.119-.026c-4.842-.598-10.225.856-13.85 4.024a12.384 12.384 0 0 0-3.158 4.146c-1.365-1.774-3.559-2.792-5.867-2.724-3.004.189-5.559 2.151-6.393 4.906a.773.773 0 0 0 .374.872c.436.354.954.605 1.512.733 1.197.242 2.405.463 3.613.664 2.361.391 4.737.711 7.124.955 1.576.16 3.155.287 4.739.381 3.272.196 6.56.243 9.838.145 1.624-.052 3.186-.104 4.669-.784a6.846 6.846 0 0 0 2.682-2.224 7.205 7.205 0 0 0 .986-6.277ZM249.843 131.676a6.778 6.778 0 0 0-.304-1.704c-.838-2.601-3.215-4.483-6.056-4.79a.471.471 0 0 0-.092 0c-.041-.01-.082-.021-.125-.026a18.847 18.847 0 0 0-7.957.778c-3.932 1.255-7.384 3.781-9.046 7.391-1.367-1.775-3.563-2.793-5.874-2.722-3.002.187-5.558 2.15-6.391 4.905a.785.785 0 0 0 .374.871c.437.353.954.605 1.511.733a114.156 114.156 0 0 0 10.736 1.619c4.844.495 9.716.671 14.583.527 1.62-.052 3.186-.105 4.67-.785a6.794 6.794 0 0 0 2.675-2.224 7.087 7.087 0 0 0 1.296-4.573Z",
    style: {
      fill: "#7cbbff"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M438.22 298.782a84.697 84.697 0 0 1-4.032 27.734c-.101.327-.222.654-.343.979h-59.346a49.074 49.074 0 0 1 4.011-11.515c4.939-9.982 13.002-18.523 20.965-27.006 10.967-11.689 21.67-23.282 23.363-38.484a85.57 85.57 0 0 1 10.321 20.287 25.346 25.346 0 0 0-8.284 4.837c-.666.595-1.371 1.459-1.028 2.285.322.691 1.208.92 1.995 1.074 1.895.347 3.79.693 5.685 1.018 1.491.287 3.003.557 4.516.825a89.91 89.91 0 0 1 2.177 17.966Z",
    style: {
      fill: "#007013"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M488.072 292.563c-9.516 5.509-15.563 14.03-20.502 23.57-4.297.932-8.266 2.917-11.51 5.757-.686.596-1.392 1.458-1.029 2.286.303.689 1.21.92 1.997 1.074 1.874.344 3.789.69 5.663 1.018-.181.402-.362.825-.544 1.227h-62.894a86.214 86.214 0 0 1 9.454-10.288c.747-.711 1.513-1.381 2.297-2.072 8.019-6.899 17.224-12.432 27.216-16.353 15.738-6.265 32.95-8.413 49.852-6.219Z",
    style: {
      fill: "#00b913"
    }
  }), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M409.737 327.495h-56.001a82.51 82.51 0 0 1 .08-12.82c2.238-26.354 17.296-51.459 40.015-66.662-2.902 9.848-1.411 19.637 1.612 29.463-.423.135-.846.25-1.229.403a25.308 25.308 0 0 0-8.285 4.838c-.666.595-1.371 1.458-1.03 2.284.304.691 1.211.921 1.997 1.074 1.895.346 3.79.692 5.664 1.018 1.512.288 3.024.556 4.536.844.707.115 1.41.25 2.117.384.101.231.161.442.262.653 3.548 9.308 7.418 18.694 9.232 28.233.45 2.395.759 4.81.928 7.236.06 1.018.102 2.035.102 3.052Z",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M104.531 298.782a84.67 84.67 0 0 1-4.032 27.734 19.28 19.28 0 0 1-.342.979H40.809a49.08 49.08 0 0 1 4.013-11.515c4.938-9.982 13.002-18.523 20.964-27.006 10.967-11.689 21.67-23.282 23.363-38.484a85.57 85.57 0 0 1 10.321 20.287 25.346 25.346 0 0 0-8.284 4.837c-.665.595-1.371 1.459-1.028 2.285.322.691 1.21.92 1.996 1.074 1.895.347 3.79.693 5.684 1.018 1.491.287 3.004.557 4.516.825a89.983 89.983 0 0 1 2.177 17.966Z",
    style: {
      fill: "#00ba19"
    }
  }), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M154.383 292.563c-9.515 5.509-15.563 14.03-20.503 23.57-4.296.932-8.264 2.917-11.509 5.757-.685.596-1.391 1.458-1.028 2.286.301.689 1.21.92 1.996 1.074 1.874.344 3.788.69 5.664 1.018-.182.402-.363.825-.545 1.227H65.564a86.14 86.14 0 0 1 9.455-10.288c.746-.711 1.512-1.381 2.297-2.072 8.018-6.899 17.224-12.432 27.215-16.353 15.738-6.265 32.949-8.413 49.852-6.219Z",
    fill: "#f2f2f2"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M76.047 327.495h-56a82.263 82.263 0 0 1 .081-12.82c2.238-26.354 17.295-51.459 40.015-66.662-2.903 9.848-1.412 19.637 1.612 29.463-.423.135-.847.25-1.231.403a25.329 25.329 0 0 0-8.285 4.838c-.664.595-1.369 1.458-1.028 2.284.303.691 1.211.921 1.996 1.074 1.895.346 3.79.692 5.664 1.018 1.512.288 3.025.556 4.536.844.707.115 1.412.25 2.118.384.098.231.161.442.261.653 3.549 9.308 7.418 18.694 9.233 28.233.45 2.395.758 4.81.926 7.236.062 1.018.102 2.035.102 3.052Z",
    style: {
      fill: "#00640c"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "m284.526 305.108 50.037 4.23.536.047v-203.29l-.536-.354a158.891 158.891 0 0 0-33.59-16.99l-2.558 33.577-.232 3.074-2.529 33.298-.781 10.243-10.255 134.981-.092 1.184ZM160.784 102.31c-.356.217-.715.434-1.072.661v206.414l1.072-.094 49.497-4.183-.093-1.184-10.254-134.981-.78-10.243-2.53-33.298-.234-3.074-2.68-35.212a159.328 159.328 0 0 0-32.926 15.194Z",
    style: {
      fill: "#3b3b3b"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M159.712 102.971c-.721.442-1.44.896-2.151 1.356v207.874c0 5.194 3.235 9.547 7.559 10.656a8.67 8.67 0 0 0 2.165.274h160.779a8.61 8.61 0 0 0 2.161-.274 9.338 9.338 0 0 0 4.214-2.403c2.196-2.235 3.396-5.193 3.347-8.253V107.943a131.613 131.613 0 0 0-2.687-1.848l-.536-.354v206.46a8.029 8.029 0 0 1-.248 1.986c-.764 3.069-3.283 5.317-6.251 5.317H167.285c-3.586 0-6.501-3.274-6.501-7.303V102.31c-.356.217-.715.434-1.072.661Z",
    style: {
      fill: "#2f2f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    style: {
      fill: "#2f2f2f"
    },
    d: "M159.173 122.329h177.002v3.074H159.173z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M281.964 83.123c-1.073-.252-2.145-.49-3.229-.71v83.457h3.229V83.123ZM216.613 81.375c-1.079.191-2.157.387-3.229.598v83.897h3.229V81.375Z",
    style: {
      fill: "#2f2f2f"
    }
  }), /*#__PURE__*/React.createElement("path", {
    d: "M124.469 317.75c0 1.766.355 3.513 1.046 5.149.266.635.582 1.248.948 1.835.471.766 1.02 1.489 1.636 2.157 2.752 2.986 6.725 4.699 10.899 4.699h211.974c11.183 0 18.173-11.529 12.582-20.751-2.595-4.28-7.393-6.915-12.582-6.915H138.998c-8.019.006-14.518 6.193-14.529 13.826Z",
    style: {
      fill: "#272727"
    }
  }), /*#__PURE__*/React.createElement("path", {
    transform: "rotate(180 0 0)",
    style: {
      fill: "#2f2f2f"
    },
    d: "M-335.099-168.946h175.927v10.245h-175.927z"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M239.605 155.627h15.062c0 3.111-2.648 5.634-5.917 5.634h-3.227c-3.27 0-5.918-2.523-5.918-5.634Z",
    style: {
      fill: "#2f2f2f",
      transformOrigin: "247.136px 158.444px"
    },
    transform: "rotate(180 0 0)"
  }), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M11.286 325.653a152.593 152.593 0 0 0 15.233 14.932h436.926a152.583 152.583 0 0 0 15.232-14.932H11.286Z",
    fill: "#3f3d56"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M226.175 275.72v52.899h38.92V275.72c.001-.78-.532-1.471-1.316-1.701a1.82 1.82 0 0 0-.558-.084h-35.167c-1.038-.001-1.879.798-1.879 1.785Zm15.189 18.177c.03-3.046 3.51-4.918 6.265-3.371 1.256.705 2.03 1.984 2.044 3.371v6.138c-.016 3.044-3.489 4.93-6.25 3.395-1.269-.706-2.052-1.997-2.059-3.395v-6.138Z",
    fill: "#2f2e41"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M226.054 326.927v5.1c.004.55.469.997 1.046 1.001h37.069c.578-.002 1.045-.448 1.045-1.001v-5.1h-39.16ZM164.946 196.022v96.585c.002 2.562 2.183 4.639 4.875 4.64h150.323c2.691-.001 4.872-2.078 4.875-4.64v-96.585c-.007-2.561-2.186-4.633-4.875-4.637H169.821c-2.689.004-4.869 2.076-4.875 4.637Z",
    fill: "#3f3d56"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M168.471 197.223v94.192c.003 1.37 1.169 2.48 2.606 2.482h147.814c1.439-.002 2.604-1.112 2.606-2.482v-94.192c0-1.37-1.165-2.482-2.606-2.484H171.077c-1.44.002-2.606 1.114-2.606 2.484Z",
    fill: "#6c63ff"
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    d: "M198.612 334.229c.306.365.768.577 1.257.573h87.94c1.025-.001 1.793-.899 1.582-1.856l-1.365-6.174a1.568 1.568 0 0 0-1.008-1.119 1.628 1.628 0 0 0-.574-.103h-85.215c-.197 0-.391.034-.575.103a1.56 1.56 0 0 0-1.006 1.119l-1.366 6.174c-.099.454.022.926.33 1.283Z",
    fill: "#2f2e41"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    x: -224.708,
    y: -208.912,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: -219.291,
    y: -208.912,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    x: -213.875,
    y: -208.912,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: -208.456,
    y: -208.912,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect5 || (_rect5 = /*#__PURE__*/React.createElement("rect", {
    x: -203.04,
    y: -208.912,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect6 || (_rect6 = /*#__PURE__*/React.createElement("rect", {
    x: -197.623,
    y: -208.912,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect7 || (_rect7 = /*#__PURE__*/React.createElement("rect", {
    x: -192.206,
    y: -208.912,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect8 || (_rect8 = /*#__PURE__*/React.createElement("rect", {
    x: -186.789,
    y: -208.912,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect9 || (_rect9 = /*#__PURE__*/React.createElement("rect", {
    x: -181.371,
    y: -208.912,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect10 || (_rect10 = /*#__PURE__*/React.createElement("rect", {
    x: -175.955,
    y: -208.912,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect11 || (_rect11 = /*#__PURE__*/React.createElement("rect", {
    x: -170.537,
    y: -208.912,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect12 || (_rect12 = /*#__PURE__*/React.createElement("rect", {
    x: -165.121,
    y: -208.912,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect13 || (_rect13 = /*#__PURE__*/React.createElement("rect", {
    x: -159.703,
    y: -208.912,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect14 || (_rect14 = /*#__PURE__*/React.createElement("rect", {
    x: -154.287,
    y: -208.912,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect15 || (_rect15 = /*#__PURE__*/React.createElement("rect", {
    x: -148.869,
    y: -208.912,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect16 || (_rect16 = /*#__PURE__*/React.createElement("rect", {
    x: -143.453,
    y: -208.912,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect17 || (_rect17 = /*#__PURE__*/React.createElement("rect", {
    x: -224.772,
    y: -211.493,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect18 || (_rect18 = /*#__PURE__*/React.createElement("rect", {
    x: -219.355,
    y: -211.493,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect19 || (_rect19 = /*#__PURE__*/React.createElement("rect", {
    x: -213.937,
    y: -211.493,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect20 || (_rect20 = /*#__PURE__*/React.createElement("rect", {
    x: -208.522,
    y: -211.493,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect21 || (_rect21 = /*#__PURE__*/React.createElement("rect", {
    x: -203.104,
    y: -211.493,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect22 || (_rect22 = /*#__PURE__*/React.createElement("rect", {
    x: -197.686,
    y: -211.493,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect23 || (_rect23 = /*#__PURE__*/React.createElement("rect", {
    x: -192.27,
    y: -211.493,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect24 || (_rect24 = /*#__PURE__*/React.createElement("rect", {
    x: -186.852,
    y: -211.493,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect25 || (_rect25 = /*#__PURE__*/React.createElement("rect", {
    x: -181.437,
    y: -211.493,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect26 || (_rect26 = /*#__PURE__*/React.createElement("rect", {
    x: -176.018,
    y: -211.493,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect27 || (_rect27 = /*#__PURE__*/React.createElement("rect", {
    x: -170.602,
    y: -211.493,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect28 || (_rect28 = /*#__PURE__*/React.createElement("rect", {
    x: -165.185,
    y: -211.493,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect29 || (_rect29 = /*#__PURE__*/React.createElement("rect", {
    x: -159.769,
    y: -211.493,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect30 || (_rect30 = /*#__PURE__*/React.createElement("rect", {
    x: -154.35,
    y: -211.493,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect31 || (_rect31 = /*#__PURE__*/React.createElement("rect", {
    x: -148.933,
    y: -211.493,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect32 || (_rect32 = /*#__PURE__*/React.createElement("rect", {
    x: -143.517,
    y: -211.493,
    width: 2.709,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 30.556 59.648)",
    fill: "#3f3d56"
  })), _rect33 || (_rect33 = /*#__PURE__*/React.createElement("rect", {
    x: -259.882,
    y: -333.882,
    width: 21.667,
    height: 1.547,
    rx: 0.488,
    transform: "rotate(180 0 0)",
    fill: "#3f3d56"
  })), _path8 || (_path8 = /*#__PURE__*/React.createElement("path", {
    d: "M178.505 207.714h138.31c.423-.01.678-.452.459-.796a.566.566 0 0 0-.459-.253h-138.31c-.424.01-.678.451-.458.797a.56.56 0 0 0 .458.252Z",
    fill: "#3f3d56"
  })), _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 307.4,
    cy: 200.854,
    rx: 3.223,
    ry: 3.138,
    fill: "#3f3d56"
  })), _ellipse2 || (_ellipse2 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 296.264,
    cy: 200.854,
    rx: 3.223,
    ry: 3.138,
    fill: "#3f3d56"
  })), _ellipse3 || (_ellipse3 = /*#__PURE__*/React.createElement("ellipse", {
    cx: 285.128,
    cy: 200.854,
    rx: 3.223,
    ry: 3.138,
    fill: "#3f3d56"
  })), _path9 || (_path9 = /*#__PURE__*/React.createElement("path", {
    d: "M184.62 199.066c-.002.312.263.566.59.567h7.909c.462-.011.738-.492.497-.866a.602.602 0 0 0-.497-.274h-7.909a.584.584 0 0 0-.59.573ZM184.62 201.205a.578.578 0 0 0 .59.568h7.909c.462-.009.739-.491.498-.865a.6.6 0 0 0-.498-.274h-7.909a.582.582 0 0 0-.59.571ZM184.62 203.341a.583.583 0 0 0 .59.573h7.909c.462-.01.738-.492.497-.868a.605.605 0 0 0-.497-.272h-7.909c-.327.001-.592.255-.59.567Z",
    fill: "#3f3d56"
  })), _rect34 || (_rect34 = /*#__PURE__*/React.createElement("rect", {
    x: 182.663,
    y: 219.884,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect35 || (_rect35 = /*#__PURE__*/React.createElement("rect", {
    x: 215.164,
    y: 219.884,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect36 || (_rect36 = /*#__PURE__*/React.createElement("rect", {
    x: 224.373,
    y: 219.884,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect37 || (_rect37 = /*#__PURE__*/React.createElement("rect", {
    x: 191.503,
    y: 219.637,
    width: 20.782,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect38 || (_rect38 = /*#__PURE__*/React.createElement("rect", {
    x: 234.839,
    y: 219.637,
    width: 20.782,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect39 || (_rect39 = /*#__PURE__*/React.createElement("rect", {
    x: 192.019,
    y: 231.55,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6",
    transform: "translate(-.688 -4.961)"
  })), _rect40 || (_rect40 = /*#__PURE__*/React.createElement("rect", {
    x: 223.832,
    y: 226.589,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect41 || (_rect41 = /*#__PURE__*/React.createElement("rect", {
    x: 233.04,
    y: 226.59,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect42 || (_rect42 = /*#__PURE__*/React.createElement("rect", {
    x: 200.17,
    y: 226.342,
    width: 20.782,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect43 || (_rect43 = /*#__PURE__*/React.createElement("rect", {
    x: 243.507,
    y: 226.342,
    width: 20.782,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect44 || (_rect44 = /*#__PURE__*/React.createElement("rect", {
    x: 199.997,
    y: 233.295,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect45 || (_rect45 = /*#__PURE__*/React.createElement("rect", {
    x: 232.498,
    y: 233.295,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect46 || (_rect46 = /*#__PURE__*/React.createElement("rect", {
    x: 241.708,
    y: 233.295,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect47 || (_rect47 = /*#__PURE__*/React.createElement("rect", {
    x: 208.838,
    y: 233.046,
    width: 20.782,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect48 || (_rect48 = /*#__PURE__*/React.createElement("rect", {
    x: 252.174,
    y: 233.046,
    width: 20.782,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect49 || (_rect49 = /*#__PURE__*/React.createElement("rect", {
    x: 208.664,
    y: 239.999,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect50 || (_rect50 = /*#__PURE__*/React.createElement("rect", {
    x: 241.166,
    y: 239.999,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect51 || (_rect51 = /*#__PURE__*/React.createElement("rect", {
    x: 250.373,
    y: 239.999,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect52 || (_rect52 = /*#__PURE__*/React.createElement("rect", {
    x: 217.505,
    y: 239.752,
    width: 20.782,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect53 || (_rect53 = /*#__PURE__*/React.createElement("rect", {
    x: 243.801,
    y: 277.213,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6",
    transform: "translate(-28.637 -10.55)"
  })), _rect54 || (_rect54 = /*#__PURE__*/React.createElement("rect", {
    x: 253.01,
    y: 277.213,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6",
    transform: "translate(-28.637 -10.55)"
  })), _rect55 || (_rect55 = /*#__PURE__*/React.createElement("rect", {
    x: 234.839,
    y: 266.91,
    width: 20.782,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect56 || (_rect56 = /*#__PURE__*/React.createElement("rect", {
    x: 182.662,
    y: 266.662,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect57 || (_rect57 = /*#__PURE__*/React.createElement("rect", {
    x: 191.503,
    y: 266.91,
    width: 20.782,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect58 || (_rect58 = /*#__PURE__*/React.createElement("rect", {
    x: 191.331,
    y: 259.957,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect59 || (_rect59 = /*#__PURE__*/React.createElement("rect", {
    x: 223.832,
    y: 259.957,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect60 || (_rect60 = /*#__PURE__*/React.createElement("rect", {
    x: 233.04,
    y: 259.957,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect61 || (_rect61 = /*#__PURE__*/React.createElement("rect", {
    x: 200.17,
    y: 260.205,
    width: 20.782,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect62 || (_rect62 = /*#__PURE__*/React.createElement("rect", {
    x: 199.997,
    y: 253.251,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect63 || (_rect63 = /*#__PURE__*/React.createElement("rect", {
    x: 232.498,
    y: 253.251,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect64 || (_rect64 = /*#__PURE__*/React.createElement("rect", {
    x: 241.708,
    y: 253.251,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect65 || (_rect65 = /*#__PURE__*/React.createElement("rect", {
    x: 208.838,
    y: 253.498,
    width: 20.782,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect66 || (_rect66 = /*#__PURE__*/React.createElement("rect", {
    x: 237.301,
    y: 257.096,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6",
    transform: "translate(-28.637 -10.55)"
  })), _rect67 || (_rect67 = /*#__PURE__*/React.createElement("rect", {
    x: 241.166,
    y: 246.547,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect68 || (_rect68 = /*#__PURE__*/React.createElement("rect", {
    x: 250.374,
    y: 246.547,
    width: 5.963,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _rect69 || (_rect69 = /*#__PURE__*/React.createElement("rect", {
    x: 217.505,
    y: 246.793,
    width: 20.782,
    height: 2.971,
    rx: 2.88,
    fill: "#e6e6e6"
  })), _path10 || (_path10 = /*#__PURE__*/React.createElement("path", {
    d: "M200.835 362.966c-.12.056-.24.113-.358.165a162.77 162.77 0 0 1-9.22 4.007 159.733 159.733 0 0 1-18.943 6.205c-1.083-6.432-2.134-21.601-3.142-32.756-.191-2.1-.379-4.055-.568-5.784a48.266 48.266 0 0 0-1.024-6.745 2.25 2.25 0 0 0-.212-.501c.103.892.212 3.554.314 7.246.054 1.73.103 3.684.158 5.784.254 10.738.52 25.348.785 33.669a163.157 163.157 0 0 1-5.466 1.186 164.934 164.934 0 0 1-32.204 3.161c-.678 0-1.349-.005-2.026-.009-.206 0-.413-.006-.623-.011-.596-.011-1.214-.02-1.842-.037a163.53 163.53 0 0 1-35.665-4.894l.47-33.066.082-5.784.031-2.191a7.566 7.566 0 0 0-.476 2.191c-.189 1.409-.384 3.406-.579 5.784-.742 9.16-1.506 23.936-2.297 32.344-9.365-2.538-16.214-4.854-24.772-8.929a82.024 82.024 0 0 1-.996-.474c.06-.397.124-.794.184-1.201.968-6.417-.173-14.767.899-21.74.818-5.379 1.663-10.548 2.513-14.932 1.029-5.277 2.075-9.424 3.109-11.441a733.718 733.718 0 0 1 3.538-6.807c.497-.944.987-1.87 1.468-2.781.26-.49.52-.974.775-1.449a286.908 286.908 0 0 1 3.255-5.925 135.714 135.714 0 0 1 1.951-3.354 50.406 50.406 0 0 1 1.826-2.848c3.761-5.428 9.356-9.469 15.86-11.455l.162-.04.157.061.18.079 10.324-3.596 4.61-10.569 23.678-1.387 3.824 2.769 1.957 1.42 2.084 1.511 3.836 2.779 1.088.32 1.619.475 11.079 3.239.115-.047.162.042c5.918 1.804 11.099 5.319 14.82 10.058.369.453.71.922 1.04 1.397.899 1.269 2.113 3.275 3.543 5.792a245.078 245.078 0 0 1 1.869 3.354c.396.716 3.808 10.855 7.129 21.214 3.104 9.696 6.127 19.583 6.523 22.121.069.47.146.943.215 1.413.45 2.934.894 5.889 1.322 8.773a1081.092 1081.092 0 0 0 1.859 12.194Z",
    fill: "#3f3d56"
  })), _path11 || (_path11 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m175.741 325.63-4.602-16.914-4.064 14.595 8.666 2.319z"
  })), /*#__PURE__*/React.createElement("path", {
    d: "M19.861 325.433c.489 1.358 1.842 2.261 3.35 2.234l14.35-.351c1.52-.027 2.838-1.006 3.24-2.402l2.03-20.675c.721.31 1.505.464 2.297.449 4.027-.097 6.434-4.309 4.334-7.582-.976-1.518-2.728-2.426-4.598-2.382a4.495 4.495 0 0 0-.94.094 3.638 3.638 0 0 0-2.64-1.086l-22.075.543a3.424 3.424 0 0 0-.544.065c-2.056.363-3.301 2.374-2.64 4.262l3.836 26.831Zm23.387-22.599 1.446-4.928a3.214 3.214 0 0 0 .01-1.74c.069 0 .132-.032.202-.032 2.881-.056 4.747 2.879 3.358 5.283-.642 1.109-1.854 1.811-3.182 1.844a3.638 3.638 0 0 1-1.834-.427Z",
    style: {
      fill: "#33412e"
    }
  }), _path12 || (_path12 = /*#__PURE__*/React.createElement("path", {
    d: "M18.665 294.34c.47 2.559 5.757 4.361 12.114 4.048 5.847-.257 10.628-2.212 11.504-4.528a3.4 3.4 0 0 0-.999-.128l-22.075.543a3.424 3.424 0 0 0-.544.065Z",
    fill: "#3f3d56"
  })), _path13 || (_path13 = /*#__PURE__*/React.createElement("path", {
    d: "M31.946 314.072a.263.263 0 0 0 .081-.034l3.117-1.941a.252.252 0 0 0 0-.432l-3.239-2.02c-.174-.11-.407.001-.42.198a.255.255 0 0 0 .124.232l2.893 1.805-2.771 1.727a.251.251 0 0 0 .026.445.273.273 0 0 0 .189.02ZM27.023 314.289c.202-.05.273-.288.129-.43a.3.3 0 0 0-.061-.045l-2.873-1.567 2.777-1.965a.251.251 0 0 0-.053-.442.28.28 0 0 0-.27.03l-3.109 2.197a.253.253 0 0 0 .027.432l3.232 1.763a.28.28 0 0 0 .201.027ZM31.636 315.775a.36.36 0 0 0 .074-.03.251.251 0 0 0 .09-.355l-4.417-6.917a.278.278 0 0 0-.469.014.246.246 0 0 0 .005.256l4.419 6.915a.276.276 0 0 0 .298.117Z",
    fill: "#6c63ff"
  })), _path14 || (_path14 = /*#__PURE__*/React.createElement("path", {
    d: "M436.603 363.526c-.331.16-.666.319-.997.474-8.558 4.075-15.405 6.391-24.772 8.929-.792-8.408-1.555-23.184-2.296-32.344-.196-2.378-.391-4.375-.58-5.783a7.532 7.532 0 0 0-.476-2.192l.032 2.192.082 5.783.471 33.067a163.739 163.739 0 0 1-35.667 4.894c-.628.016-1.245.025-1.842.036-.21.005-.417.01-.622.01-.678.005-1.348.01-2.026.01a164.058 164.058 0 0 1-37.669-4.347c.264-8.32.529-22.931.784-33.67.054-2.099.104-4.054.158-5.783.102-3.693.211-6.354.314-7.246a2.216 2.216 0 0 0-.212.5 48.258 48.258 0 0 0-1.024 6.746 337.812 337.812 0 0 0-.569 5.783c-1.007 11.156-2.058 26.324-3.141 32.757a159.936 159.936 0 0 1-18.944-6.206 156.51 156.51 0 0 1-9.576-4.172c.596-3.714 1.218-7.875 1.858-12.193a1789.46 1789.46 0 0 1 1.539-10.186c.812-5.251 28.417-61.951 34.923-63.936l.162-.042.113.046 11.078-3.238 1.62-.475 1.09-.32 3.833-2.779 2.086-1.512 1.956-1.418 3.825-2.77 23.678 1.388 4.61 10.568 10.324 3.596.179-.078.157-.062.164.04c6.503 1.986 12.098 6.028 15.859 11.455a51.26 51.26 0 0 1 1.826 2.849c.596.984 1.246 2.109 1.951 3.35 1 1.771 2.095 3.768 3.255 5.928a399.069 399.069 0 0 1 2.242 4.23 758.534 758.534 0 0 1 3.539 6.807c1.033 2.018 2.08 6.164 3.109 11.441.851 4.383 1.694 9.552 2.512 14.932 1.073 6.972-.069 15.324.901 21.74.058.407.124.804.183 1.201Z",
    fill: "#3f3d56"
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 564.975,
    cy: 222.637,
    r: 50.836,
    fill: "#ffb6b6",
    transform: "matrix(.5417 0 0 .51578 61.111 119.296)"
  })), _path15 || (_path15 = /*#__PURE__*/React.createElement("path", {
    opacity: 0.2,
    d: "m323.122 325.63 4.603-16.914 4.064 14.595-8.667 2.319z"
  })), _path16 || (_path16 = /*#__PURE__*/React.createElement("path", {
    d: "M445.607 314.609c-1.648 21.601.059 31.113-9.031 48.922a159.707 159.707 0 0 1-28.509 10.121 163.739 163.739 0 0 1-35.667 4.894c-.628.016-1.245.025-1.842.036-.21.005-.417.01-.622.01-.678.005-1.348.01-2.026.01a164.058 164.058 0 0 1-41.359-5.26 159.936 159.936 0 0 1-18.944-6.206 156.51 156.51 0 0 1-9.576-4.172c-.711-.341-1.421-.681-2.118-1.032-3.592-6.013-5.636-13.327-5.678-22.116 2.487-15.144 149.879-38.265 155.372-25.207Z",
    fill: "#2f2e41"
  })), _path17 || (_path17 = /*#__PURE__*/React.createElement("path", {
    d: "M445.601 318.31a321.5 321.5 0 0 1 .289-4.158c-5.493-13.06-152.885 10.063-155.371 25.207.007 1.388.068 2.734.173 4.05 6.023-14.946 146.046-36.923 154.909-25.099Z",
    opacity: 0.2
  })), _path18 || (_path18 = /*#__PURE__*/React.createElement("path", {
    d: "m286.57 315.629 12.097-5.759-10.081-25.919-2.657-13.071c-1.514-7.442-10.9-10.56-16.946-5.626-4.247 3.467-4.845 9.518-1.349 13.678l9.861 11.738 9.075 24.959Z",
    fill: "#ffb6b6"
  })), _path19 || (_path19 = /*#__PURE__*/React.createElement("path", {
    d: "m298.667 305.069-16.129 7.68 12.242 36.522c1.787 5.334 6.376 9.387 12.097 10.686 7.117 1.612 14.513-1.351 18.277-7.323l32.463-52.978c4.783-7.593 2.331-17.433-5.525-22.169-8.607-5.191-20.041-2.122-24.536 6.584l-19.814 40.197-9.075-19.199Z",
    fill: "#3f3d56"
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 117.529,
    cy: 214.03,
    r: 55.935,
    fill: "#a0616a",
    transform: "matrix(.5417 0 0 .51578 61.111 119.296)"
  })), _path20 || (_path20 = /*#__PURE__*/React.createElement("path", {
    d: "M94.841 209.806c2.464-3.161 6.004-5.409 8.713-8.383 1.486-1.633 2.72-3.482 4.391-4.942 3.105-2.716 7.445-3.828 11.657-3.966 9.362-.229 18.28 3.801 24.014 10.852l6.607-3.689c.87 2.18 1.737 4.361 2.607 6.542 2.327-1.925 5.969-.731 6.558 2.149a3.654 3.654 0 0 1-.455 2.62c.523-1.542 2.924-1.87 4.248-.851 1.324 1.018 1.678 2.831 1.462 4.438-.554 3.608-3.356 6.532-7.076 7.388-2.874.612-6.219-.03-8.518 1.72-1.844 1.403-2.4 3.958-4.282 5.313-2.318 1.672-5.595.899-8.477 1.268-5.042.647-9.035 5.557-8.429 10.366-.457-1.517-.936-3.078-1.972-4.312-1.034-1.232-2.778-2.066-4.367-1.613-2.624.75-3.054 4.156-2.418 6.694 1.687 6.731 8.083 17.61 8.083 17.61-8.303 3.119-18.196.17-24.603-5.748-6.406-5.917-9.743-14.296-11.196-22.681-1.232-7.11-1.058-14.985 3.453-20.775ZM401.67 248.582c5.765-12.584 2.5-24.165-4.528-30.308v-.005c-2.762-5.896-6.435-10.445-10.638-11.511-2.033-1.244-4.006-2.704-6.193-3.446a8.434 8.434 0 0 0-6.328.272l-1.115-.284c-.948-2.304-2.058-2.35-3.294-.835-4.757-2.109-9.04-3.052-12.854-3.052-12.438 0-19.794 10.026-21.744 22.146l10.395 2.637 3.613-5.483-1.668 5.978 5.736 1.448c8.733 10.828-1.717 35.801-14.961 49.696a125.715 125.715 0 0 1 9.42-2.104l11.365-15.866-7.043 14.443c3.658-.512 8.322-.021 13.419.964 1.716-2.135 2.621-4.984 1.733-7.52a27.832 27.832 0 0 1 2.97 8.525c10.757 2.502 25.431 3.786 33.34 4.737 6.391-1.988 6.408-24.42-1.625-30.432Z",
    fill: "#2f2e41"
  })), _path21 || (_path21 = /*#__PURE__*/React.createElement("path", {
    d: "M405.421 205.776c4.222 9.002-4.298 12.873-12.103 12.764-7.052-.098-13.045-4.816-13.406-11.522-.361-6.708 5.06-12.422 12.102-12.766 7.045-.343 10.53 5.392 13.407 11.524Z",
    fill: "#2f2e41"
  })), _path22 || (_path22 = /*#__PURE__*/React.createElement("path", {
    d: "m209.539 352.319-6.955-11.047 23.126-16.706 9.616-9.664c5.474-5.506 15.151-3.332 17.467 3.921 1.627 5.098-1.281 10.506-6.579 12.228l-14.94 4.857-21.735 16.411Z",
    fill: "#a0616a"
  })), _path23 || (_path23 = /*#__PURE__*/React.createElement("path", {
    d: "m214.566 351.954-10.828 8.593-2.92 2.316-.341.268a162.77 162.77 0 0 1-9.22 4.007 159.733 159.733 0 0 1-22.632 7.118 163.157 163.157 0 0 1-5.466 1.186c-.611.124-1.225.242-1.837.356-3.328-3.015-5.212-7.201-5.211-11.574 0-.139 0-.283.005-.428l1.74-42.464.769-18.82c.246-8.853 7.865-15.9 17.167-15.876.519 0 1.034.026 1.543.072.369.454.71.923 1.04 1.397.899 1.269 2.113 3.275 3.543 5.793a250.8 250.8 0 0 1 1.869 3.353c.396.716 3.808 10.855 7.129 21.214l-1.463 10.815-2.643 19.497 10.844-6.778 7.638-4.776.905 1.439 2.356 3.744 4.551 7.222 1.462 2.326Z",
    fill: "#3f3d56"
  })), _path24 || (_path24 = /*#__PURE__*/React.createElement("path", {
    d: "M208.63 339.817a51.116 51.116 0 0 1-.077 2.589 47.644 47.644 0 0 1-.856 6.995 39.482 39.482 0 0 1-3.959 11.146c-.25.469-.515.933-.787 1.387-.698.35-1.406.691-2.116 1.032-.12.056-.24.113-.358.165a157.232 157.232 0 0 1-9.22 4.007 159.733 159.733 0 0 1-22.632 7.118 160.972 160.972 0 0 1-7.303 1.542 164.934 164.934 0 0 1-30.367 2.805c-.678 0-1.349-.004-2.026-.009-.206 0-.413-.005-.623-.01-.596-.011-1.214-.021-1.842-.037a163.592 163.592 0 0 1-38.434-5.616 159.818 159.818 0 0 1-25.74-9.399c-9.092-17.808-7.386-27.32-9.032-48.921 3.381-8.041 60.568-2.362 104.598 6.721 11.949 2.465 22.924 5.183 31.597 7.948 8.96 2.852 15.456 5.751 18.001 8.475a4.036 4.036 0 0 1 1.176 2.062Z",
    fill: "#2f2e41"
  })), _path25 || (_path25 = /*#__PURE__*/React.createElement("path", {
    d: "M53.261 318.31c-.084-1.338-.177-2.72-.287-4.158 5.493-13.06 152.884 10.063 155.37 25.207a53.72 53.72 0 0 1-.173 4.05c-6.022-14.946-146.046-36.923-154.91-25.099Z",
    opacity: 0.2
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgWhySenior);
export default __webpack_public_path__ + "static/media/whySenior.73da78b578e2b7a489ec80a85a04dc2a.svg";
export { ForwardRef as ReactComponent };